import React from "react";

const AethirSvg = ({...props}) => {
  return (
    <svg
      width="238"
      height="70"
      viewBox="0 0 238 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_250_1032"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="68"
        y="0"
        width="170"
        height="64"
      >
        <path
          d="M233.399 0.991668L68.1035 15.4531L72.287 63.2705L237.582 48.809L233.399 0.991668Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_250_1032)">
        <path
          d="M207.246 12.0299C209.645 11.8199 211.421 9.70585 211.211 7.30797C211.001 4.91009 208.886 3.13646 206.486 3.3464C204.086 3.55634 202.311 5.67041 202.52 8.0683C202.73 10.4662 204.846 12.2398 207.246 12.0299Z"
          fill="#CFB2FF"
        />
        <path
          d="M86.0654 15.3852L72.2017 62.303L80.0475 61.6166L83.7687 48.7549L102.348 47.1295L108.19 59.1544L116.101 58.4623L94.301 14.6647L86.0654 15.3852ZM90.7579 23.463L91.0177 23.4403L99.635 41.0331L85.323 42.2852L90.7547 23.4633L90.7579 23.463Z"
          fill="#CFB2FF"
        />
        <path
          d="M137.784 25.0923C135.202 23.7096 132.161 23.1678 128.656 23.4744C125.152 23.781 122.503 24.7321 120.186 26.3704C117.868 28.0087 116.166 30.2044 115.078 32.9547C113.99 35.7051 113.595 38.7869 113.894 42.2006C114.192 45.6143 115.126 48.6881 116.671 51.1652C118.216 53.6427 120.282 55.4859 122.871 56.6949C125.461 57.9035 128.398 58.366 131.684 58.0785C134.363 57.8441 136.692 57.1924 138.667 56.1303C140.642 55.0651 142.209 53.6788 143.368 51.9653C144.524 50.2555 145.25 48.3412 145.546 46.226L138.671 46.8275C138.352 48.16 137.565 49.3636 136.306 50.4283C135.048 51.4964 133.339 52.1234 131.179 52.3123C128.111 52.5808 125.659 51.7196 123.829 49.7248C122.415 48.1841 121.502 46.0961 121.086 43.4678L145.442 41.337C145.588 37.5379 144.994 34.2252 143.661 31.4055C142.324 28.5829 140.366 26.4817 137.784 25.0954L137.784 25.0923ZM121.427 34.9463C122.013 33.1979 122.95 31.8212 124.233 30.8165C125.516 29.8114 127.069 29.2308 128.885 29.072C130.96 28.8904 132.73 29.226 134.198 30.0753C135.667 30.9277 136.741 32.1383 137.425 33.7102C137.843 34.6742 138.09 35.7283 138.173 36.8753L120.816 38.3939C120.867 37.1533 121.071 36.0043 121.427 34.9463Z"
          fill="#CFB2FF"
        />
        <path
          d="M193.38 19.3434C191.475 18.4866 189.268 18.1696 186.762 18.3889C183.949 18.635 181.695 19.4631 179.986 20.8747C178.744 21.9022 177.774 23.2361 177.069 24.8639L175.554 7.54908L168.614 8.15625L172.583 53.514L179.523 52.9068L178.111 36.7731C177.779 32.9731 178.295 30.0442 179.662 27.9856C181.027 25.9304 183.05 24.7823 185.733 24.5476C187.98 24.351 189.725 24.885 190.968 26.1462C192.21 27.4077 192.955 29.4448 193.2 32.2519L194.89 51.5592L201.829 50.952L200.015 30.217C199.777 27.4942 199.087 25.2168 197.948 23.3806C196.805 21.5451 195.284 20.197 193.379 19.3399L193.38 19.3434Z"
          fill="#CFB2FF"
        />
        <path
          d="M211.228 17.2288L204.288 17.8359L207.145 50.4931L214.085 49.8859L211.228 17.2288Z"
          fill="#CFB2FF"
        />
        <path
          d="M224.134 16.0991C221.799 16.3033 220.061 17.0863 218.917 18.4485C217.773 19.8107 217.303 21.6567 217.507 23.9899L219.729 49.3881L226.669 48.7809L224.334 22.0881L235.164 21.1406L234.642 15.1797L224.137 16.0988L224.134 16.0991Z"
          fill="#CFB2FF"
        />
        <path
          d="M154.026 12.0491L147.086 12.6562L150.192 48.1625C150.396 50.4955 151.18 52.2318 152.543 53.3746C153.906 54.5178 155.754 54.9871 158.088 54.7828L168.594 53.8637L168.073 47.9028L157.242 48.8503L155.428 28.115L166.259 27.1674L165.737 21.2065L154.907 22.1541L154.022 12.0494L154.026 12.0491Z"
          fill="#CFB2FF"
        />
      </g>
      <mask
        id="mask1_250_1032"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="17"
        width="63"
        height="52"
      >
        <path
          d="M58.6946 17.7598L0.942383 22.8125L4.90491 68.1044L62.6572 63.0517L58.6946 17.7598Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_250_1032)">
        <path
          d="M35.9124 19.7529L23.7216 20.8195C22.3172 20.9424 21.1079 21.8549 20.6089 23.1667L15.5031 36.5883C14.864 38.2671 16.2063 40.0319 18.0035 39.8747L26.414 39.1388C27.5838 39.0365 28.5914 38.2759 29.0083 37.1821L30.8675 32.2954L44.5961 55.2963L27.8967 45.353C27.2333 44.9589 26.4626 44.7816 25.6918 44.849L14.1925 45.8551C12.7884 45.9779 11.5791 46.8906 11.0798 48.2024L4.84421 64.6047C4.20545 66.2831 5.5478 68.0482 7.34494 67.891L15.7555 67.1552C16.925 67.0529 17.9328 66.2923 18.3498 65.1985L23.4133 51.8906L41.5698 63.2982C43.0183 64.2076 44.7243 64.6207 46.4302 64.4715L60.217 63.2653C62.0142 63.1081 63.0296 61.1367 62.1091 59.5946L39.3854 21.524C38.6659 20.3188 37.3166 19.6301 35.9124 19.7529Z"
          fill="#CFB2FF"
        />
      </g>
    </svg>
  );
};

export default AethirSvg;
